import { store } from '../config/configureStore';

function formatNumber(number, decimals, isCurrency = false, isFractional = false, currencyCode = 'BRL') {
  number = parseFloat(number);

  const style = isCurrency ? 'currency' : 'decimal';
  const fractionalQuantity = store.getState().app.permissionsCompany
  && store.getState().app.permissionsCompany.fractionalQuantity;

  return new Intl.NumberFormat('pt-BR', {
    style,
    currency: currencyCode,
    minimumFractionDigits: (!fractionalQuantity && !isCurrency && !isFractional) ? 0 : decimals,
    maximumFractionDigits: (!fractionalQuantity && !isCurrency && !isFractional) ? 0 : decimals,
  }).format(number);
}

function getLocaleCurrency(language, value) {
  switch (language) {
    case 'pt-BR':
      return `R$${value}`;
    default:
      return `$${value}`;
  }
}

function formatDate(date, options = {}) {
  if (date) {
    const { format = 'dd/MM/yyyy' } = options;

    return new Intl.DateTimeFormat('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  }
}

function getOrdinal(language, number) {
  const ordinalSuffixes = {
    en: ['th', 'st', 'nd', 'rd'],
    pt: ['º', 'ª'],
    es: ['º', 'ª'],
  };

  if (language.slice(0, 2) === 'en') {
    if (number % 10 === 1 && number % 100 !== 11) return `${number}${ordinalSuffixes.en[1]}`;
    if (number % 10 === 2 && number % 100 !== 12) return `${number}${ordinalSuffixes.en[2]}`;
    if (number % 10 === 3 && number % 100 !== 13) return `${number}${ordinalSuffixes.en[3]}`;
    return `${number}${ordinalSuffixes.en[0]}`;
  }
  return `${number}${ordinalSuffixes[language.slice(0, 2)][0]}`;
}

function getPhoneMask(value = '', isNew = false) {
  const cleaned = value ? value.replace(/\D/g, '') : '';

  if (isNew) {
    return '';
  }

  // Define a máscara com base no comprimento do número
  if (cleaned.length <= 8) {
    return '9999-9999'; // Máscara para números locais (sem DDD)
  } if (cleaned.length <= 10) {
    return '(99) 9999-9999'; // Máscara para números com DDD
  } if (cleaned.length <= 11) {
    return '(99) 99999-9999'; // Máscara para números com DDD e 9 dígitos
  } if (cleaned.length <= 13) {
    return '+99 (99) 99999-9999'; // Máscara para números com DDI(2), DDD e 9 dígitos
  } if (cleaned.length <= 14) {
    return '+999 (99) 99999-9999'; // Máscara para números com DDI(3), DDD e 9 dígitos
  }
  return ''; // Máscara padrão
}

function formatCpfOrCnpj(digits) {
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
  } if (digits.length === 14) {
    // eslint-disable-next-line max-len
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`;
  }
  return digits;
}

export default {
  formatNumber,
  getLocaleCurrency,
  formatDate,
  getOrdinal,
  formatCpfOrCnpj,
  getPhoneMask,
};
